module.exports = __webpack_public_path__ + "static/jon-29bb6150f06fcb594bbfe1941ebf4c95.jpg";